import { Get, Post, Put, Delete } from '../../api/axiosCoreConfig';

export const getAppointments = async (clinicId, date, patientId, namespace) =>
    await Get(
        `/appointment?${clinicId ? 'clinic_id=' + clinicId : ''}${
            date?.from ? '&from_date=' + date?.from : ''
        }${date?.to ? '&to_date=' + date?.to : ''}${patientId ? '&patient=' + patientId : ''}${
            '&namespace=' + namespace
        }`
    );
export const createAppointment = async (appointment) => await Post('/appointment', appointment);
export const getAppointmentDetail = async (appointmentId, namespace) =>
    await Get(`/appointment/${appointmentId}?namespace=${namespace}`);
export const editAppointment = async (appointmentId, appointment) =>
    await Put(`/appointment/${appointmentId}`, appointment);
export const deleteAppointment = async (appointmentId, namespace) =>
    await Delete(`/appointment/${appointmentId}?namespace=${namespace}`);
export const reorderAppointments = async (appointmentId, position, prevId, namespace) => {
    let param = position ? { position, namespace } : { put_after_id: prevId, namespace };
    return await Post(`/appointment/${appointmentId}/reorder`, param);
};
export const changeStateOfAppointment = async (appointmentId, appointment) =>
    await Post(`/appointment/${appointmentId}/state/change`, appointment);
export const getAdmissionDetail = (id, namespace) => Get(`/admission/${id}?namespace=${namespace}`);
export const editAdmission = (id, admission) => Put(`/admission/${id}`, admission);
